import { z } from 'zod';
/** Salon (Wettbewerb) aus dem Katalog der FIAP-Liste, wie ihn die API ausgibt. */
export const salonSchema = z.object({
    id: z.number().int(),
    fiapNumber: z.string(),
    year: z.number().int(),
    name: z.string(),
    country: z.string().nullable(),
    kind: z.string().nullable(),
    sectionsCount: z.number().int().nullable(),
    categories: z.array(z.string()),
    price: z.string().nullable(),
    /** Termine als reines Datum `JJJJ-MM-TT`. */
    closingDate: z.string().nullable(),
    judgingDate: z.string().nullable(),
    notificationDate: z.string().nullable(),
    info: z.string().nullable(),
    email: z.string().nullable(),
    homepage: z.string().nullable(),
});
/** Abfrageparameter der Salonsuche (alle optional). */
export const salonSearchQuerySchema = z.object({
    /** Teil des Namens oder der FIAP-Nummer. */
    q: z.string().trim().max(100).optional(),
    /** Kanonischer Ländername. */
    country: z.string().trim().max(100).optional(),
    /** Einsendeschluss ab (einschließlich). */
    from: z.iso.date().optional(),
    /** Einsendeschluss bis (einschließlich). */
    to: z.iso.date().optional(),
    /** Salonart (Teilstring, z. B. `PI`). */
    kind: z.string().trim().max(20).optional(),
    year: z.coerce.number().int().min(2000).max(2100).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    offset: z.coerce.number().int().min(0).default(0),
});
/** Antwort der Salonsuche. */
export const salonSearchResponseSchema = z.object({
    items: z.array(salonSchema),
    total: z.number().int(),
});
/** Auswahlwerte für die Filter der Salonsuche. */
export const salonFacetsSchema = z.object({
    years: z.array(z.number().int()),
    countries: z.array(z.object({ name: z.string(), count: z.number().int() })),
    kinds: z.array(z.string()),
});
/** Ein Eintrag im Importbericht (Fehler brechen den Import ab, Warnungen nicht). */
export const importIssueSchema = z.object({
    level: z.enum(['error', 'warning']),
    fiapNumber: z.string().nullable(),
    message: z.string(),
});
/** Zusammenfassung eines Salonlisten-Imports (Vorschau oder Echtlauf). */
export const importSummarySchema = z.object({
    runId: z.number().int(),
    dryRun: z.boolean(),
    total: z.number().int(),
    inserted: z.number().int(),
    updated: z.number().int(),
    unchanged: z.number().int(),
    skipped: z.number().int(),
    countryUnmatched: z.number().int(),
    issues: z.array(importIssueSchema),
});
/** Eintrag der Importprotokoll-Liste in der Administration. */
export const importRunSchema = z.object({
    id: z.number().int(),
    kind: z.string(),
    filename: z.string().nullable(),
    dryRun: z.boolean(),
    inserted: z.number().int(),
    updated: z.number().int(),
    skipped: z.number().int(),
    failed: z.boolean(),
    issueCount: z.number().int(),
    createdAt: z.string(),
    username: z.string().nullable(),
});
/** Antwort der Importprotokoll-Liste. */
export const importRunListSchema = z.object({ runs: z.array(importRunSchema) });
//# sourceMappingURL=salons.js.map